<revamp-svg-sprite />
<header class="och" [class.is-scrolled]="scrolled()">
  @if (vm().courseProgress != null) {
    <i class="crs-prog" [style.--pct.%]="vm().courseProgress" [attr.aria-label]="'menu.courseProgress' | translate: { percent: vm().courseProgress }"></i>
  }
  @if (vm().showNav) {
    <a class="och-logo" routerLink="/home">
      <span class="plinth">
        @if (vm().logoUrl) {
          <img [src]="vm().logoUrl" [alt]="vm().schoolName + ' logo'" />
        } @else {
          <b class="hd-face plinth-letter">{{ vm().logoLetter }}</b>
        }
      </span>
      <span class="och-logo-name"><b class="hd-face">{{ vm().schoolName }}</b></span>
    </a>

    <nav
      class="och-nav"
      #navEl
      [attr.aria-label]="'menu.primaryNavigation' | translate"
      [style.--ux.px]="underline().x"
      [style.--uw]="underline().w"
      [style.--uo]="underline().o"
      (mouseover)="onNavHover($event)"
      (mouseleave)="resetUnderline()"
    >
      <div class="och-nav-links">
        @for (l of navLinks(); track l.id) {
          @if (l.routerLink) {
            <a
              class="nl"
              [routerLink]="l.routerLink"
              routerLinkActive="is-active"
              [class.is-hid]="hiddenIds().has(l.id)"
              (click)="onLinkNavigated()"
            >{{ l.labelKey ? (l.labelKey | translate) : l.label }}</a>
          } @else if (l.href) {
            <a
              class="nl"
              [href]="l.href"
              [target]="l.target ?? '_self'"
              [attr.data-custom]="l.custom ? '' : null"
              [class.is-hid]="hiddenIds().has(l.id)"
            >{{ l.labelKey ? (l.labelKey | translate) : l.label }}</a>
          } @else {
            <a
              class="nl"
              tabindex="0"
              role="button"
              [class.is-hid]="hiddenIds().has(l.id)"
              (click)="onActionLink(l, $event)"
              (keydown.enter)="onActionLink(l, $event)"
              (keydown.space)="onActionLink(l, $event)"
            >{{ l.labelKey ? (l.labelKey | translate) : l.label }}</a>
          }
        }
      </div>
      @if (hiddenLinks().length > 0) {
        <div class="och-more pop" [class.open]="openPop() === 'more'">
          <button type="button" (click)="togglePop('more', $event)" aria-haspopup="true" [attr.aria-expanded]="openPop() === 'more'">
            {{ 'menu.more' | translate }}
            <svg class="car" width="12" height="12"><use xlink:href="#revamp-caret"></use></svg>
          </button>
          <div class="panel from-left">
            @for (l of hiddenLinks(); track l.id) {
              @if (l.routerLink) {
                <a class="p-item" [routerLink]="l.routerLink" (click)="onLinkNavigated()">{{ l.labelKey ? (l.labelKey | translate) : l.label }}</a>
              } @else if (l.href) {
                <a class="p-item" [href]="l.href" [target]="l.target ?? '_self'">{{ l.labelKey ? (l.labelKey | translate) : l.label }}</a>
              } @else {
                <button class="p-item" type="button" (click)="onActionLink(l, $event)">{{ l.labelKey ? (l.labelKey | translate) : l.label }}</button>
              }
            }
          </div>
        </div>
      }
    </nav>
  } @else {
    <span class="och-flex-spacer"></span>
  }

  <div class="och-acts">
    @if (vm().showSearch) {
      <div class="och-search" [class.open]="searchOpen()" #searchWrap (click)="onSearchClick($event)">
        <button
          class="och-search-trigger ic-chip"
          type="button"
          [attr.aria-label]="'allLessons.searchAllLessons' | translate"
          [attr.aria-expanded]="searchOpen()"
          (click)="openSearch($event)"
        >
          <svg width="17" height="17"><use xlink:href="#revamp-search"></use></svg>
        </button>
        <div class="och-search-field">
          <search
            [indexes]="['lessons']"
            [placeholder]="'allLessons.searchAllLessons' | translate"
            searchIconMarginTop="11px"
            (optionSelected)="searchSelected.emit($event); searchOpen.set(false)"
          ></search>
        </div>
      </div>
    }

    @if (vm().showTrial) {
      <div class="trial">
        <span class="ring" aria-hidden="true" [style.background]="trialRingStyle()"></span>
        <span class="tx">Trial expires in <b>{{ vm().trialDaysLeft }}</b> days</span>
        <button class="up" type="button" (click)="upgradeClicked.emit()">Upgrade</button>
      </div>
    }

    @if (vm().showUpgrade) {
      <button class="up up-solo" type="button" (click)="upgradeClicked.emit()">
        <svg width="16" height="16"><use xlink:href="#revamp-upgrade"></use></svg>
        Upgrade
      </button>
    }

    @if (vm().showAiAssistant) {
      <button class="ic-chip ai-chip" type="button" aria-label="AI Assistant" matTooltip="AI Assistant" (click)="aiAssistantClicked.emit($event)">
        <global-ai-icon-svg />
      </button>
    }

    @if (vm().showNotifications) {
      <button
        class="ic-chip"
        type="button"
        [attr.aria-label]="'menu.notifications.text' | translate"
        (click)="onNotificationsClicked()"
      >
        <svg width="18" height="18"><use xlink:href="#revamp-bell"></use></svg>
        @if (vm().unreadCount > 0) {
          <span class="badge">{{ vm().unreadCount }}</span>
        }
      </button>
    }

    @if (vm().showTestPill) {
      <div
        class="test-pill"
        matTooltip="Your user is currently a Stripe test user. All interactions with Stripe like course purchase etc. will be with fake credit cards like 424242. Notice that to perform the initial connection to Stripe, you can't be in Test mode."
      >Test</div>
    }

    @if (vm().loggedOut) {
      <button class="login-pill" type="button" (click)="loginClicked.emit()">{{ 'menu.login' | translate }}</button>
    }

    @if (vm().loggedIn) {
      <div class="pop me" [class.open]="openPop() === 'me'">
        <button class="avatar-btn" type="button" [attr.aria-label]="'menu.accountMenu' | translate" aria-haspopup="true" [attr.aria-expanded]="openPop() === 'me'" (click)="togglePop('me', $event)">
          @if (vm().avatarUrl) {
            <img class="av-img" [src]="vm().avatarUrl" alt="" />
          } @else {
            {{ vm().avatarInitials }}
          }
        </button>
        <div class="panel panel-me">
          <div class="p-me">
            <span class="av">
              @if (vm().avatarUrl) {
                <img [src]="vm().avatarUrl" alt="" />
              } @else {
                {{ vm().avatarInitials }}
              }
            </span>
            <span class="p-me-id"><b>{{ vm().userName }}</b><small>{{ vm().userEmail }}</small></span>
          </div>
          @if (continueWatching(); as cw) {
            <a class="p-item p-resume" [routerLink]="cw.routerLink" (click)="onLinkNavigated()">
              <span class="pic"><svg width="14" height="14"><use xlink:href="#revamp-play"></use></svg></span>
              <span class="p-resume-body">
                <b>{{ 'menu.continueWatching' | translate }}</b>
                <small>{{ cw.courseTitle }}</small>
                @if (cw.percent != null) {
                  <span class="rbar"><i [style.width.%]="cw.percent"></i></span>
                }
              </span>
              @if (cw.percent != null) {
                <span class="tag">{{ cw.percent }}%</span>
              }
            </a>
            <div class="p-sep"></div>
          }
          @if (vm().isStudent) {
            <a class="p-item" routerLink="/user-settings/my-account" (click)="onLinkNavigated()">
              <span class="pic"><svg width="15" height="15"><use xlink:href="#revamp-user"></use></svg></span>
              {{ 'menu.myAccount' | translate }}
            </a>
            @if (vm().showMyCertificates) {
              <a class="p-item" routerLink="/user-settings/my-certificates" (click)="onLinkNavigated()">
                <span class="pic"><svg width="15" height="15"><use xlink:href="#revamp-certificate"></use></svg></span>
                {{ 'menu.myCertificates' | translate }}
              </a>
            }
            @if (vm().showAffiliateProgram) {
              <a class="p-item" routerLink="/user-settings/my-affiliate-program" (click)="onLinkNavigated()">
                <span class="pic"><svg width="15" height="15"><use xlink:href="#revamp-affiliate"></use></svg></span>
                {{ 'menu.joinAffiliateProgram' | translate }}
              </a>
            }
            @if (vm().showCreateYourCourse) {
              <a class="p-item" href="https://onlinecoursehost.com" target="_blank" (click)="onLinkNavigated()">
                <span class="pic"><svg width="15" height="15"><use xlink:href="#revamp-create-course"></use></svg></span>
                {{ 'menu.createYourCourse' | translate }}
              </a>
            }
            <div class="p-sep"></div>
          }
          <button class="p-item" type="button" (click)="logoutClicked.emit()">
            <span class="pic"><svg width="15" height="15"><use xlink:href="#revamp-logout"></use></svg></span>
            {{ 'menu.logout' | translate }}
          </button>
        </div>
      </div>
    }

    @if (vm().showBurger) {
      <button class="burger" type="button" [attr.aria-label]="'menu.openMenu' | translate" (click)="drawerOpen.set(true)">
        <svg width="20" height="20"><use xlink:href="#revamp-burger"></use></svg>
      </button>
    }
  </div>
</header>

<!-- mobile drawer -->
<div class="veil" [class.show]="drawerOpen()" (click)="drawerOpen.set(false)"></div>
<aside class="drawer" [class.open]="drawerOpen()" aria-label="Menu">
  <div class="dw-top">
    <span class="och-logo">
      <span class="plinth">
        @if (vm().logoUrl) {
          <img [src]="vm().logoUrl" [alt]="vm().schoolName + ' logo'" />
        } @else {
          <b class="hd-face plinth-letter">{{ vm().logoLetter }}</b>
        }
      </span>
      <span class="och-logo-name"><b class="hd-face">{{ vm().schoolName }}</b></span>
    </span>
    <button class="dw-close" type="button" [attr.aria-label]="'menu.closeMenu' | translate" (click)="drawerOpen.set(false)">
      <svg width="18" height="18"><use xlink:href="#revamp-close"></use></svg>
    </button>
  </div>
  @if (vm().showSearch) {
    <div class="dw-search">
      <search
        [indexes]="['lessons']"
        [placeholder]="'allLessons.searchAllLessons' | translate"
        (optionSelected)="searchSelected.emit($event); drawerOpen.set(false)"
      ></search>
    </div>
  }
  <nav class="dw-nav">
    @for (l of navLinks(); track l.id; let i = $index) {
      @if (l.routerLink) {
        <a [routerLink]="l.routerLink" routerLinkActive="is-active" [style.--i]="i" (click)="onLinkNavigated()">{{ l.labelKey ? (l.labelKey | translate) : l.label }}</a>
      } @else if (l.href) {
        <a [href]="l.href" [target]="l.target ?? '_self'" [style.--i]="i" (click)="onLinkNavigated()">{{ l.labelKey ? (l.labelKey | translate) : l.label }}</a>
      } @else {
        <a tabindex="0" role="button" [style.--i]="i" (click)="onActionLink(l, $event)" (keydown.enter)="onActionLink(l, $event)" (keydown.space)="onActionLink(l, $event)">{{ l.labelKey ? (l.labelKey | translate) : l.label }}</a>
      }
    }
  </nav>
  <div class="dw-bottom">
    @if (vm().showTrial) {
      <div class="dw-trial">
        <span class="ring" aria-hidden="true" [style.background]="trialRingStyle()"></span>
        <span class="tx">Trial expires in <b>{{ vm().trialDaysLeft }}</b> days</span>
        <button class="up" type="button" (click)="upgradeClicked.emit()">Upgrade</button>
      </div>
    }
    @if (vm().showUpgrade) {
      <button class="up dw-upgrade" type="button" (click)="upgradeClicked.emit()">
        <svg width="16" height="16"><use xlink:href="#revamp-upgrade"></use></svg>
        Upgrade
      </button>
    }
    @if (vm().loggedOut) {
      <button class="login-pill dw-login" type="button" (click)="loginClicked.emit()">{{ 'menu.login' | translate }}</button>
    }
    @if (vm().loggedIn) {
      <div class="dw-me">
        <span class="av">
          @if (vm().avatarUrl) {
            <img [src]="vm().avatarUrl" alt="" />
          } @else {
            {{ vm().avatarInitials }}
          }
        </span>
        <span class="dw-me-id"><b>{{ vm().userName }}</b><small>{{ vm().userEmail }}</small></span>
        <button class="out" type="button" [attr.aria-label]="'menu.logout' | translate" (click)="logoutClicked.emit()">
          <svg width="16" height="16"><use xlink:href="#revamp-logout"></use></svg>
        </button>
      </div>
    }
  </div>
</aside>
